import {
	SET_ORGANIZATION_DATA,
} from './OrganizationTypes';

export const setOrganizationData = (data) => async (dispatch) => {
	dispatch({ type: SET_ORGANIZATION_DATA, payload: data });
};

